/**
 * The available header types.
 */
enum HeaderTypes
{
    ClientName = 'ClientName',
    ConnectionStatus = 'ConnectionStatus',
    ProxyName = 'ProxyName',
    ProxyId = 'ProxyId',
    None = "None",
}

export default HeaderTypes;
